import React, { useRef, useEffect, useState } from 'react'
import PropTypes from 'prop-types'

import {
  View,
  Image,
  Easing,
  Animated,
  Platform,
  TextInput,
  TouchableOpacity,
  ActivityIndicator,
  useWindowDimensions,
  Dimensions
} from 'react-native'

import Modal from 'react-native-modal'

import ContentManager from '@vfgroup-oneplatform/foundation/ContentManager'

import {
  VFText,
  VFButton,
  Icon
} from '@vfgroup-oneplatform/foundation/Components'
import {
  Colors,
  useTheme,
  withTheme,
  LightThemeColors
} from '@vfgroup-oneplatform/foundation/Components/Themes'

import _Modal from 'react-native-modal'


// import MapView, { Marker, PROVIDER_GOOGLE, Polygon } from 'react-native-maps'
// import { GooglePlacesAutocomplete } from 'react-native-google-places-autocomplete'

// import Geolocation from '@react-native-community/geolocation'

// import {
//   request,
//   RESULTS,
//   PERMISSIONS,
//   openSettings,
//   check as checkPermissions
// } from 'react-native-permissions'

import { getAddress } from '../../Services'

import CustomButton from '../../Components/CustomButton'

import { getThemeImages } from '../../Themes'

import mapConfig from './mapConfig.json'

import styles from './CoverageScreen.Styles'

import UhImages from '../../Themes/Images'

import { LocationSelector } from '@vfal-lab/rn-vfg-renewals-fix/Screens/PurchaseCoverage/PurchaseCoverage'
import { MapWrapper } from '@vfal-lab/rn-vfg-renewals-fix/Screens/PurchaseCoverage/Map'
import axios from 'axios'

const INITIAL_REGION = {
  latitude: 41.3275,
  longitude: 19.8187,
  latitudeDelta: 0.015,
  longitudeDelta: 0.0121
}

const CoveragePolygons = PropTypes.objectOf({
  city: PropTypes.string,
  country: PropTypes.string,
  id: PropTypes.number,
  polygonCoords: PropTypes.arrayOf(
    PropTypes.objectOf({
      latitude: PropTypes.number,
      longitude: PropTypes.number
    })
  )
})

// const LOCATION_PERMISSION =
//   Platform.OS === 'ios'
//     ? PERMISSIONS.IOS.LOCATION_WHEN_IN_USE
//     : PERMISSIONS.ANDROID.ACCESS_FINE_LOCATION

const CoverageScreen = ({
  show,
  theme,
  title,
  street,
  apiKey,
  onNext,
  onClose,
  polygons,
  subtitle,
  latitude,
  longitude,
  buttonText,
  onMapReady,
  onLocationChange,
  // Coverage
  hasCoverage,
  isCoverageError,
  onNoCoverageClose,
  isCheckingCoverage,
  coverageErrorTitle,
  onCoverageErrorClose,
  coverageErrorMessage,
  setMap,
  getCoveragePolygons,
  validateLocation
}) => {
  const { height } = useWindowDimensions()
  const [city, setCity] = useState('')
  const latlng = useRef({
    lat: null,
    lng: null
  })

  const themedImages = getThemeImages(theme.name)

  const [streetName, setStreetName] = useState('')

  const getCityName = async () => {
    try {
      const { data } = await axios.get(`https://maps.googleapis.com/maps/api/geocode/json?latlng=${latlng.current.lat},${latlng.current.lng}&sensor=true&key=AIzaSyDgZm5OUSqiyK7fEstVVKhQCtQvkEvXjZo`)
      data?.results?.map(item => {
        if (item?.types[0] === "administrative_area_level_1") {
          getCoveragePolygons(item?.formatted_address.split(' ')[0]?.replace('ë', 'e') + '')
        }
      })
    } catch (error) {
      console.log("🚀 ~ file: CoverageScreen.js:130 ~ getCityName ~ error:", error)
    }
  }

  const getRoadName = async ({ lat, lng }) => {
    try {
      const { data } = await axios.get(`https://maps.googleapis.com/maps/api/geocode/json?latlng=${lat},${lng}&sensor=true&key=AIzaSyDgZm5OUSqiyK7fEstVVKhQCtQvkEvXjZo`)
      data?.results?.map(item => {
        if (item?.types[0] === "route") {
          setStreetName(item?.formatted_address)
        }
      })
    } catch (error) {
      console.log("🚀 ~ file: CoverageScreen.js:130 ~ getCityName ~ error:", error)
    }
  }

  const onMapShow = () => {
    navigator.geolocation.getCurrentPosition(({ coords }) => {
      latlng.current = {
        lat: coords.latitude,
        lng: coords.longitude
      }
      getCityName()
    }, (e) => {
      latlng.current = {
        lat: 41.3275,
        lng: 19.8187
      }
      getCityName()
    }, { timeout: 10000 })
  }

  const _validateLocation = (cords) => {
    validateLocation({
      body: {
        longitude: cords.latLng.lng(),
        latitude: cords.latLng.lat()
      }
    })
  }



  const handleLocationChange = data => {
    getAddress({ coordinate: data, apiKey })
      .then(result => {
        onLocationChange({ ...data, ...result.data })
      })
      .catch(() => {
        onLocationChange(data)
      })
  }

  if (Platform.OS === 'web' && Dimensions.get('window').width > 700) {
    return (
      <_Modal
        isVisible={show}
        backdropOpacity={0.5}
        onSwipeComplete={(prev) => setMap({ ...prev, show: false })}
        onBackdropPress={(prev) => setMap({ ...prev, show: false })}
        propagateSwipe
        hideModalContentWhileAnimating
        hardwareAccelerated
        backdropTransitionOutTiming={0}
        style={{
          justifyContent: 'flex-end',
          margin: '0 !important',
          minWidth: 1920,
          maxWidth: 1920,
        }}
      >
        <View style={{
          minWidth: 600,
          minHeight: 600,
          backgroundColor: theme.colors.quickActionGradientColors.secondary,
          margin: 'auto',
          padding: '20px',
          borderRadius: "7px",
        }}>
          <View style={{ flexDirection: 'row', justifyContent: 'space-between' }} >
            <VFText
              weight="bold"
              size="h1"
              align="left"
              color={theme.colors.textColor}
              i18nKey="renewals_verify_coverage"
            />
            <TouchableOpacity onPress={(prev) => setMap({ ...prev, show: false })} >
              <Icon
                name={themedImages.ic_close}
                size={25}
                resizeMode='contain'
              />
            </TouchableOpacity>
          </View>

          <VFText
            weight="regular"
            size="body"
            align="left"
            color={theme.colors.textColorTwo}
            i18nKey="renewals_verify_coverage_desc"
            style={styles.descText}
          />
          <MapWrapper
            onSearch={handleLocationChange}
            API_KEY={apiKey}
            theme={theme}
            serviceAreas={polygons}
            setServiceAreas={() => { }}
            UnlimitedHome={true}
            onMapShow={onMapShow}
            validateLocation={_validateLocation}
            isSearching={true}
            inputStyle={{ top: null }}
            getRoadName={getRoadName}
            streetName={streetName}
            setStreetName={setStreetName}
          />
          <OfferForYouButton
            onPress={onNext}
            text={buttonText}
            isLoading={isCheckingCoverage}
            show={hasCoverage === true}
          />
          <NoCoverageModal
            onClose={onNoCoverageClose}
            show={hasCoverage === false}
            primary={theme.colors.textColor}
            secondary={theme.colors.textColorTwo}
          />
          <CoverageErrorModal
            show={isCoverageError}
            title={coverageErrorTitle}
            onClose={onCoverageErrorClose}
            message={coverageErrorMessage}
            primary={theme.colors.textColor}
            secondary={theme.colors.textColorTwo}
          />

          <LoadingIndicator show={isCheckingCoverage} extraStyles={{ display: 'flex', justifyContent: 'center' }} />
        </View>
      </_Modal>
    )
  }

  return (
    <Modal
      isVisible={show}
      statusBarTranslucent
      animationIn="slideInUp"
      style={styles.noMargin}
      onRequestClose={onClose}
      onBackButtonPress={onClose}
      backdropTransitionOutTiming={0}
      backdropTransitionInTiming={650}
    >
      <View style={styles.modalContainer}>
        <View style={styles.modal(height, theme)}>
          <View style={styles.titleContainer}>
            <VFText
              i18nKey={title}
              style={styles.title}
              color={theme.colors.textColorTwo}
            />
            <TouchableOpacity onPress={onClose}>
              <Icon
                size={25}
                type="image"
                resizeMode="contain"
                name={themedImages.ic_close}
              />
            </TouchableOpacity>
          </View>
          <VFText
            i18nKey={subtitle}
            style={styles.description}
            color={theme.colors.textColorTwo}
          />
          <MapWrapper
            // updateCoordinates={updateCoordinates}
            // updateCurrentCoordinates={updateCurrentCoordinates}
            // goToSteps={goToSteps}
            // inputRef={inputRef}
            onSearch={handleLocationChange}
            // successSearch={successSearch}
            // geographicAddress={geographicAddress}
            // geographicAddressLoading={geographicAddressLoading}
            // validationAddressLoading={validationAddressLoading}
            API_KEY={apiKey}
            theme={theme}
            // isContentLoading={isCheckingCoverage}
            // isErrorSearch={isErrorSearch}
            // onCancelNotifyMe={onCancelNotifyMe}
            // toggleModal={onClose}
            serviceAreas={polygons}
            setServiceAreas={() => { }}
            // areItemsFetching={areItemsFetching}
            // setSuccessSearch={setSuccessSearch}
            UnlimitedHome={true}
            onMapShow={onMapShow}
            validateLocation={_validateLocation}
            inputStyle={{ top: null }}
            getRoadName={getRoadName}
            streetName={streetName}
            setStreetName={setStreetName}
          />
          <OfferForYouButton
            onPress={onNext}
            text={buttonText}
            isLoading={isCheckingCoverage}
            show={hasCoverage === true}
          />
          <NoCoverageModal
            onClose={onNoCoverageClose}
            show={hasCoverage === false}
            primary={theme.colors.textColor}
            secondary={theme.colors.textColorTwo}
          />
          <CoverageErrorModal
            show={isCoverageError}
            title={coverageErrorTitle}
            onClose={onCoverageErrorClose}
            message={coverageErrorMessage}
            primary={theme.colors.textColor}
            secondary={theme.colors.textColorTwo}
          />
          {isCheckingCoverage &&
            <div style={{
              position: 'fixed',
              width: '100%',
              height: '100%',
              opacity: '0.2',
              backgroundColor: 'rgba(0,0,0,0.5)',
            }}>
              <LoadingIndicator show={isCheckingCoverage} />
            </div>}
        </View>
      </View>
    </Modal>
  )
}

CoverageScreen.defaultProps = {
  theme: {
    name: 'light',
    colors: LightThemeColors
  },
  title: 'renewals_verify_coverage',
  subtitle: 'renewals_verify_coverage_desc'
}

CoverageScreen.propTypes = {
  show: PropTypes.bool,
  city: PropTypes.string,
  onNext: PropTypes.func,
  theme: PropTypes.object,
  title: PropTypes.string,
  onClose: PropTypes.func,
  street: PropTypes.string,
  apiKey: PropTypes.string,
  polygons: CoveragePolygons,
  subtitle: PropTypes.string,
  latitude: PropTypes.number,
  longitude: PropTypes.number,
  hasCoverage: PropTypes.bool,
  onMapReady: PropTypes.func,
  buttonText: PropTypes.string,
  onLocationChange: PropTypes.func,
  // Coverage
  isCoverageError: PropTypes.bool,
  onNoCoverageClose: PropTypes.func,
  isCheckingCoverage: PropTypes.bool,
  coverageErrorTitle: PropTypes.string,
  onCoverageErrorClose: PropTypes.func,
  coverageErrorMessage: PropTypes.string
}

const NoCoverageModal = ({ onClose, primary, secondary, show }) => {
  const theme = useTheme()
  if (!show) {
    return null
  }
  return (
    <View style={styles.notify(theme)}>
      <VFText
        size="h3"
        align="left"
        color={primary}
        weight="regular"
        style={styles.header}
        i18nKey="notify_me_subtitle"
      />
      <VFText
        size="body"
        align="left"
        weight="regular"
        color={secondary}
        style={styles.description}
        i18nKey="notify_me_desc"
      />
      <VFButton
        type="primary"
        onPress={onClose}
        style={styles.primary}
        title="notify_me_cancel_button_label"
      />
    </View>
  )
}

NoCoverageModal.propTypes = {
  show: PropTypes.bool,
  onClose: PropTypes.func,
  primary: PropTypes.string,
  secondary: PropTypes.string
}

const Map = ({
  city,
  theme,
  street,
  apiKey,
  polygons,
  longitude,
  latitude,
  isLoading,
  onMapReady,
  onLocationChange,
  onAutocompletePress
}) => {
  const mapRef = useRef(null)

  const [opacity] = useState(new Animated.Value(0))

  const autocompleteRef = useRef(null)

  const animate = () => {
    opacity.setValue(0)
    Animated.timing(opacity, {
      toValue: 1,
      duration: 600,
      easing: Easing.linear,
      useNativeDriver: true
    }).start()
  }

  const onMapPress = ({ nativeEvent: { coordinate } }) => {
    onLocationChange(coordinate)
    animateToRegion(coordinate)
  }

  const onCurrentLocationPress = coordinate => {
    onLocationChange(coordinate)
    animateToRegion(coordinate)
  }

  const animateToRegion = coords => {
    mapRef.current.animateToRegion({
      ...INITIAL_REGION,
      ...coords
    })
    animate()
  }

  const handleAutocompleteSelect = (description, details) => {
    const long = details?.geometry?.location?.lng
    const lat = details?.geometry?.location?.lat
    if (long && lat) {
      onAutocompletePress({ longitude: long, latitude: lat })
      animateToRegion({ longitude: long, latitude: lat })
    }
  }

  return (
    <View style={styles.map}>
      {/* <MapView
        onPress={onMapPress}
        style={styles.mapView}
        onMapReady={onMapReady}
        provider={PROVIDER_GOOGLE}
        initialRegion={INITIAL_REGION}
        ref={ref => (mapRef.current = ref)}
        customMapStyle={mapConfig[theme.name]}
      >
        <MapMarker
          scale={1}
          opacity={opacity}
          latitude={latitude}
          longitude={longitude}
        />
        <MapPolygons polygons={polygons} />
      </MapView>
      <LoadingIndicator show={isLoading} />
      <LocationAutocomplete
        city={city}
        theme={theme}
        apiKey={apiKey}
        street={street}
        inputRef={autocompleteRef}
        onSelect={handleAutocompleteSelect}
      />
      <CurrentLocation
        isDisabled={isLoading}
        onPress={onCurrentLocationPress}
      /> */}
    </View>
  )
}

Map.propTypes = {
  city: PropTypes.string,
  street: PropTypes.string,
  theme: PropTypes.object,
  apiKey: PropTypes.string,
  isLoading: PropTypes.bool,
  latitude: PropTypes.number,
  polygons: CoveragePolygons,
  onMapReady: PropTypes.func,
  longitude: PropTypes.number,
  onLocationChange: PropTypes.func,
  onAutocompletePress: PropTypes.func
}

const MapMarker = ({ opacity, scale, longitude, latitude }) => {
  if (!longitude || !latitude) {
    return null
  }

  return (
    <Marker.Animated
      style={{ opacity: opacity }}
      anchor={{ x: 0.5, y: 0.925 }}
      key={`${longitude}_${latitude}`}
      coordinate={{ longitude, latitude }}
    >
      <Animated.View style={{ transform: [{ scale: scale }] }}>
        <Image source={UhImages.marker} style={styles.marker} />
      </Animated.View>
    </Marker.Animated>
  )
}

MapMarker.propTypes = {
  scale: PropTypes.number,
  opacity: PropTypes.number,
  latitude: PropTypes.number,
  longitude: PropTypes.number
}

const MapPolygons = React.memo(({ polygons }) => {
  if (!Array.isArray(polygons) || !polygons.length) {
    return null
  }
  return polygons.map(polygon => (
    <Polygon
      strokeWidth={2}
      key={polygon.id}
      strokeColor="#117C92"
      coordinates={polygon.polygonCoords}
      fillColor="rgba(17, 125, 146, 0.6)"
    />
  ))
})

MapPolygons.propTypes = {
  polygons: CoveragePolygons
}

const LoadingIndicator = ({ show, extraStyles }) => {
  const { height } = useWindowDimensions()

  if (!show) {
    return null
  }

  return (
    <View style={[styles.loader(height), extraStyles]}>
      <ActivityIndicator size={50} color={Colors.red} />
    </View>
  )
}

LoadingIndicator.propTypes = {
  show: PropTypes.bool
}

const LocationAutocomplete = ({
  city,
  theme,
  apiKey,
  street,
  inputRef,
  onSelect
}) => {
  const queryObject = {
    key: apiKey,
    language: 'al',
    components: 'country:al'
  }

  const { width } = useWindowDimensions()

  const placeholder = ContentManager.translate('search_input_label')

  useEffect(() => {
    if (inputRef.current) {
      let text = 'Albania'
      if (street) {
        text = `${street}, ${text}`
      }
      if (city) {
        text = `${city}, ${text}`
      }
      inputRef.current.setAddressText(text)
    }
  }, [inputRef, city, street])

  return (
    <View style={styles.autocomplete}>
      <GooglePlacesAutocomplete
        fetchDetails
        disableScroll
        minLength={3}
        debounce={200}
        ref={inputRef}
        onPress={onSelect}
        query={queryObject}
        isRowScrollable={false}
        enableHighAccuracyLocation
        enablePoweredByContainer={false}
        styles={{
          row: styles.suggestionRow(theme),
          textInput: styles.autocompleteText(theme),
          description: styles.suggestionText(theme),
          textInputContainer: styles.gpaContainer(width)
        }}
        textInputProps={{
          spellCheck: false,
          autoCorrect: false,
          autoComplete: 'off',
          InputComp: TextInput,
          placeholder: placeholder,
          clearButtonMode: 'never',
          baseColor: theme.colors.textColor,
          style: styles.textInputStyle(theme),
          placeholderTextColor: theme.colors.textColor
        }}
      />
    </View>
  )
}

LocationAutocomplete.propTypes = {
  city: PropTypes.string,
  theme: PropTypes.object,
  inputRef: PropTypes.any,
  onSelect: PropTypes.func,
  apiKey: PropTypes.string,
  street: PropTypes.string
}

const OfferForYouButton = ({ text, show, isLoading, onPress }) => {
  const { width } = useWindowDimensions()

  if (!show) {
    return null
  }
  return (
    <View style={styles.button(width)}>
      <CustomButton
        title={text}
        type="primary"
        onPress={onPress}
        isLoading={isLoading}
        loadingTitle="unlimited_processing"
      />
    </View>
  )
}

OfferForYouButton.propTypes = {
  show: PropTypes.bool,
  text: PropTypes.string,
  onPress: PropTypes.func,
  isLoading: PropTypes.bool
}

const CoverageErrorModal = ({
  show,
  title,
  onClose,
  message,
  primary,
  secondary
}) => {
  const theme = useTheme()
  if (!show) {
    return null
  }
  return (
    <View style={styles.notify(theme)}>
      <VFText
        size="h3"
        align="left"
        color={primary}
        weight="regular"
        style={styles.header}
        i18nKey={title ?? 'unlimited_error'}
      />
      <VFText
        size="body"
        align="left"
        weight="regular"
        color={secondary}
        style={styles.description}
        i18nKey={message ?? 'unlimited_coverage_error'}
      />
      <VFButton
        type="primary"
        onPress={onClose}
        style={styles.primary}
        title="unlimited_close"
      />
    </View>
  )
}

CoverageErrorModal.propTypes = {
  show: PropTypes.bool,
  title: PropTypes.string,
  onClose: PropTypes.func,
  message: PropTypes.string,
  primary: PropTypes.string,
  secondary: PropTypes.string
}

const CurrentLocation = ({ isDisabled, onPress }) => {
  const theme = useTheme()
  const themedImages = getThemeImages(theme.name)

  const pinUserLocation = () => {
    // Geolocation.getCurrentPosition(
    //   ({ coords }) => {
    //     const { longitude, latitude } = coords ?? {}
    //     if (longitude && latitude) {
    //       onPress({ longitude, latitude })
    //     }
    //   },
    //   e => { },
    //   { enableHighAccuracy: true, maximumAge: 3600000 }
    // )
  }

  const getCurrentLocation = () => {
    // checkPermissions(LOCATION_PERMISSION)
    //   .then(result => {
    //     switch (result) {
    //       case RESULTS.DENIED:
    //         request(LOCATION_PERMISSION).then(res => {
    //           if (res === 'granted') {
    //             pinUserLocation()
    //           }
    //         })
    //         break
    //       case RESULTS.GRANTED:
    //         pinUserLocation()
    //         break
    //       case RESULTS.BLOCKED:
    //         openSettings()
    //         break
    //       default:
    //         break
    //     }
    //   })
    //   .catch(err => console.error(err))
  }

  return (
    <TouchableOpacity
      activeOpacity={0.85}
      disabled={isDisabled}
      onPress={getCurrentLocation}
      style={styles.currentLocation(theme)}
    >
      <Icon
        size={35}
        type="image"
        resizeMode="contain"
        name={themedImages.location}
      />
    </TouchableOpacity>
  )
}

CurrentLocation.propTypes = {
  onPress: PropTypes.func,
  isDisabled: PropTypes.bool
}

export default withTheme(CoverageScreen)
